import { environment, setSession, setUserIndex } from '@back-office/core';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { REFRESH_TOKEN_ENDPOINT } from '../endpoints';
import { LoginResponse } from '../types';

const config: AxiosRequestConfig = {
  baseURL: environment.apiBase,
  responseType: 'json',
  withCredentials: true,
};

const refresh = (): Promise<LoginResponse> =>
  axios.get(REFRESH_TOKEN_ENDPOINT, {
    ...config,
  });

const defaultApi: AxiosInstance = axios.create({
  ...config,
});

const refreshAuthLogic = (): Promise<unknown> =>
  refresh().then((response) => {
    const { data, status } = response.data;
    if (status.code === 1000) {
      const userIndex = JSON.parse(localStorage.getItem('userIndex'));
      setSession({
        users: data.mids,
      });
      setUserIndex(userIndex);
      return Promise.resolve(data);
    }
    return Promise.reject();
  });

createAuthRefreshInterceptor(defaultApi, refreshAuthLogic);

defaultApi.interceptors.request.use(
  (req) => req,
  (error) => Promise.reject(error)
);

defaultApi.interceptors.response.use(
  (response) => response,
  (error) => error.response
);

export default defaultApi;
